import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShading5075 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 404,
	height: 116,
	viewBox: "0 0 404 116",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", { children: ".B{fill:#60c695}.C{fill:#7c6924}.D{fill:#ffad4c}.E{stroke-linecap:round}.F{fill-rule:evenodd}.G{fill:#2c3f81}" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M319.004 36v72m-120-72v72m-120-72v72",
			stroke: "#2c3f81",
			strokeWidth: 3,
			className: "E"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "A",
			maskUnits: "userSpaceOnUse",
			x: 307.004,
			y: 32,
			width: 24,
			height: 14,
			fill: "#000",
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M307.004 32h24v14h-24z"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M327.004 35c-.108 4.325-3.648 7.797-8 7.797s-7.891-3.473-8-7.797h16z",
				className: "F"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M327.004 35v-3h3.077l-.078 3.075-2.999-.075zm-16 0l-2.999.075-.077-3.075h3.076v3zm8 4.797c2.72 0 4.933-2.171 5.001-4.873l5.998.151c-.149 5.948-5.016 10.722-10.999 10.722v-6zm-5.001-4.873c.068 2.702 2.282 4.873 5.001 4.873v6c-5.982 0-10.849-4.774-10.999-10.722l5.998-.151zM311.004 32h16v6h-16v-6z",
			mask: "url(#A)",
			className: "G"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "B",
			maskUnits: "userSpaceOnUse",
			x: 187.004,
			y: 32,
			width: 24,
			height: 14,
			fill: "#000",
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M187.004 32h24v14h-24z"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M207.004 35c-.108 4.325-3.648 7.797-8 7.797s-7.891-3.473-8-7.797h16z",
				className: "F"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M207.004 35v-3h3.077l-.078 3.075-2.999-.075zm-16 0l-2.999.075-.077-3.075h3.076v3zm8 4.797c2.72 0 4.933-2.171 5.001-4.873l5.998.151c-.149 5.948-5.016 10.722-10.999 10.722v-6zm-5.001-4.873c.068 2.702 2.282 4.873 5.001 4.873v6c-5.982 0-10.849-4.774-10.999-10.722l5.998-.151zM191.004 32h16v6h-16v-6z",
			mask: "url(#B)",
			className: "G"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "C",
			maskUnits: "userSpaceOnUse",
			x: 67.004,
			y: 32,
			width: 24,
			height: 14,
			fill: "#000",
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M67.004 32h24v14h-24z"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M87.004 35c-.109 4.325-3.649 7.797-8 7.797s-7.891-3.473-8-7.797h16z",
				className: "F"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.004 35v-3h3.076l-.077 3.075L87.004 35zm-16 0l-2.999.075L67.928 32h3.076v3zm8 4.797c2.719 0 4.933-2.171 5.001-4.873l5.998.151c-.15 5.948-5.016 10.722-10.999 10.722v-6zm-5.001-4.873c.068 2.702 2.281 4.873 5.001 4.873v6c-5.983 0-10.849-4.774-10.999-10.722l5.998-.151zM71.004 32h16v6h-16v-6z",
			mask: "url(#C)",
			className: "G"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#E",
			className: "B"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#F",
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 261.405 89.5241)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 254.035 87.735)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 256.798 93.997)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 247.586 93.1024)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 253.114 80.5783)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 247.586 85.9458)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", { href: "#G" }),
				/* @__PURE__ */ _jsx("use", { href: "#H" }),
				/* @__PURE__ */ _jsx("use", { href: "#I" }),
				/* @__PURE__ */ _jsx("use", {
					href: "#E",
					x: 99
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#F",
			x: 99,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 360.405 89.5241)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 353.035 87.735)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 355.798 93.997)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 346.586 93.1024)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 352.114 80.5783)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 346.586 85.9458)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#G",
					x: 99
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: 99
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: 99
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#E",
					x: -33
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#F",
			x: -33,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 228.405 89.5241)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 221.035 87.735)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 223.798 93.997)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 214.586 93.1024)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 220.114 80.5783)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 214.586 85.9458)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#G",
					x: -33
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: -33
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: -33
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#E",
					x: 66
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#F",
			x: 66,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 327.405 89.5241)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 320.035 87.735)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 322.798 93.997)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 313.586 93.1024)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 319.114 80.5783)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 313.586 85.9458)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#G",
					x: 66
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: 66
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: 66
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#E",
					x: -66
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#F",
			x: -66,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 195.405 89.5241)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 188.035 87.735)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 190.798 93.997)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 181.586 93.1024)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 187.114 80.5783)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 181.586 85.9458)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#G",
					x: -66
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: -66
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: -66
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#E",
					x: 33
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#F",
			x: 33,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 294.405 89.5241)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 287.035 87.735)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 289.798 93.997)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 280.586 93.1024)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 286.114 80.5783)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 280.586 85.9458)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#G",
					x: 33
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: 33
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: 33
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#E",
					x: -99
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#F",
			x: -99,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 162.405 89.5241)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 155.035 87.735)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 157.798 93.997)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 148.586 93.1024)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 154.114 80.5783)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 148.586 85.9458)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#G",
					x: -99
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: -99
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: -99
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#E",
					x: -132
				})
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#F",
			x: -132,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 129.405 89.5241)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 122.035 87.735)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 124.798 93.997)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 115.586 93.1024)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 121.114 80.5783)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 115.586 85.9458)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#G",
					x: -132
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: -132
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: -132
				}),
				/* @__PURE__ */ _jsx("path", { d: "M97.973 109.839l-9.617-.395v-8.762l3.906-.026c2.401-.015 4.442-.85 6.124-2.505s2.514-3.648 2.498-5.98c-.012-1.686-.5-3.235-1.464-4.647s-2.259-2.437-3.884-3.072a8.11 8.11 0 0 0-2.879-5.27c-1.644-1.408-3.566-2.105-5.765-2.091s-4.111.736-5.735 2.166-2.56 3.199-2.806 5.307c-1.616.657-2.896 1.698-3.841 3.123s-1.412 2.98-1.4 4.666c.016 2.332.876 4.314 2.58 5.947s3.756 2.441 6.158 2.425l3.906-.025v8.788l-10.063-.043.152.539 22.132-.144z" })
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.035 100.259H85.35v8.051h3.685z",
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 96.4048 89.5241)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 89.0352 87.735)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 91.7983 93.997)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 82.5864 93.1024)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 88.1138 80.5783)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 82.5864 85.9458)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M97.248 106.147c-.005.019-.007.04-.018.056-.191.287-.281.611-.37.93-.226.8-.357 1.617-.468 2.437-.026.194.016.175-.213.178h-.181c-.765 0-1.532-.002-2.297.004-.098 0-.138-.018-.159-.11l-.468-2.163c-.126-.444-.257-.887-.454-1.31-.035-.074-.084-.142-.126-.213l.023-.015c.374.352.717.728 1.008 1.143s.542.843.745 1.3c.023-.718-.062-1.424-.148-2.129s-.256-1.393-.512-2.064c1.182 1.303 1.784 2.813 1.917 4.502.349-.979.95-1.808 1.72-2.546zm-9.041-.214c.805.674 1.39 1.491 1.807 2.418.284-1.262.919-2.344 1.873-3.273 0 .032-.014.058-.026.084-.054.122-.127.239-.157.365l-.256 1.242-.189 2.846v.108c-.03.007-.045.014-.059.014l-1.89.007c-.024 0-.064-.042-.068-.068l-.366-1.823c-.161-.655-.318-1.315-.667-1.92h-.002zm-1.202 1.344c.858.672 1.46 1.456 1.703 2.466-.371 0-.721.001-1.07-.004-.025 0-.067-.051-.071-.082l-.091-.73-.258-1.166c-.041-.157-.132-.304-.213-.484zm11.455.246c-.096.203-.203.384-.266.577-.168.516-.306 1.04-.343 1.581-.004.052-.019.072-.08.072l-.826-.007c-.032 0-.064-.005-.114-.009.32-.884.881-1.598 1.629-2.213v-.001zm-6.497.184c.667.553 1.124 1.218 1.342 2.032l-.141.007c-.256 0-.513-.004-.769.003-.098.003-.12-.028-.122-.109l-.04-.912c-.015-.273-.044-.545-.157-.803-.033-.074-.075-.145-.113-.218z" }),
				/* @__PURE__ */ _jsx("path", { d: "M89.612 106.147c-.005.019-.007.04-.018.056-.191.287-.281.611-.37.93-.226.8-.357 1.617-.468 2.437-.026.194.016.175-.213.178h-.181c-.765 0-1.532-.002-2.297.004-.099 0-.138-.018-.159-.11l-.468-2.163c-.126-.444-.257-.887-.454-1.31-.035-.074-.084-.142-.126-.213l.023-.015a7.42 7.42 0 0 1 1.008 1.143c.29.412.542.843.745 1.3.023-.718-.062-1.424-.148-2.129a8.73 8.73 0 0 0-.512-2.064c1.182 1.303 1.784 2.813 1.917 4.502.349-.979.951-1.808 1.721-2.546zm-9.041-.214c.805.674 1.39 1.491 1.807 2.418.284-1.262.918-2.344 1.873-3.273 0 .032-.014.058-.025.084-.054.122-.128.239-.157.365l-.256 1.242-.189 2.846v.108c-.03.007-.045.014-.059.014l-1.89.007c-.024 0-.064-.042-.068-.068l-.366-1.823c-.161-.655-.318-1.315-.667-1.92h-.002zm-1.202 1.344c.858.672 1.46 1.456 1.703 2.466-.371 0-.721.001-1.07-.004-.025 0-.066-.051-.071-.082l-.091-.73-.258-1.166c-.041-.157-.132-.304-.213-.484zm11.455.246c-.096.203-.203.384-.266.577-.168.516-.306 1.04-.343 1.581-.004.052-.019.072-.08.072l-.826-.007c-.032 0-.064-.005-.114-.009.32-.884.881-1.598 1.629-2.213v-.001zm-6.497.184c.667.553 1.123 1.218 1.342 2.032l-.141.007c-.256 0-.513-.004-.769.003-.098.003-.12-.028-.122-.109l-.04-.912c-.016-.273-.044-.545-.157-.803-.033-.074-.075-.145-.113-.218z" }),
				/* @__PURE__ */ _jsx("path", { d: "M85.793 106.147c-.005.019-.007.04-.018.056-.191.287-.281.611-.37.93-.226.8-.357 1.617-.467 2.437-.027.194.015.175-.213.178h-.181c-.765 0-1.532-.002-2.297.004-.098 0-.138-.018-.159-.11l-.468-2.163c-.126-.444-.257-.887-.454-1.31-.035-.074-.084-.142-.126-.213l.023-.015c.374.352.717.728 1.008 1.143s.542.843.745 1.3c.023-.718-.062-1.424-.148-2.129s-.256-1.393-.512-2.064c1.182 1.303 1.784 2.813 1.917 4.502.349-.979.95-1.808 1.72-2.546zm-9.041-.214c.805.674 1.39 1.491 1.807 2.418.284-1.262.919-2.344 1.873-3.273 0 .032-.014.058-.025.084-.054.122-.128.239-.157.365l-.256 1.242-.189 2.846v.108c-.03.007-.045.014-.059.014l-1.89.007c-.024 0-.064-.042-.068-.068l-.366-1.823c-.161-.655-.318-1.315-.667-1.92h-.002zm-1.202 1.344c.858.672 1.46 1.456 1.703 2.466-.371 0-.721.001-1.07-.004-.025 0-.067-.051-.071-.082l-.091-.73-.258-1.166c-.041-.157-.132-.304-.213-.484zm11.455.246c-.096.203-.203.384-.266.577-.168.516-.306 1.04-.343 1.581-.004.052-.019.072-.08.072l-.826-.007c-.032 0-.064-.005-.114-.009.32-.884.881-1.598 1.629-2.213v-.001zm-6.497.184c.667.553 1.124 1.218 1.342 2.032l-.141.007c-.256 0-.513-.004-.769.003-.097.003-.12-.028-.122-.109l-.04-.912c-.015-.273-.044-.545-.157-.803-.033-.074-.075-.145-.113-.218z" }),
				/* @__PURE__ */ _jsx("use", { href: "#J" })
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.035 100.259H52.35v8.051h3.685z",
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 63.4048 89.5241)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 56.0352 87.735)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 58.7983 93.997)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 49.5864 93.1024)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 55.1138 80.5783)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 49.5864 85.9458)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M64.248 106.147c-.005.019-.007.04-.018.056-.191.287-.281.611-.37.93-.226.8-.357 1.617-.467 2.437-.026.194.015.175-.213.178h-.181c-.766 0-1.532-.002-2.297.004-.098 0-.138-.018-.159-.11l-.468-2.163c-.126-.444-.257-.887-.454-1.31-.035-.074-.084-.142-.126-.213l.023-.015c.374.352.717.728 1.008 1.143s.542.843.745 1.3c.023-.718-.062-1.424-.148-2.129s-.256-1.393-.512-2.064c1.182 1.303 1.784 2.813 1.917 4.502.349-.979.95-1.808 1.72-2.546zm-9.041-.214c.805.674 1.39 1.491 1.807 2.418.284-1.262.919-2.344 1.873-3.273 0 .032-.014.058-.026.084-.054.122-.128.239-.157.365l-.256 1.242-.189 2.846v.108c-.03.007-.045.014-.059.014l-1.89.007c-.024 0-.064-.042-.068-.068l-.366-1.823c-.161-.655-.318-1.315-.667-1.92h-.002zm-1.202 1.344c.858.672 1.46 1.456 1.703 2.466-.371 0-.721.001-1.07-.004-.025 0-.067-.051-.071-.082l-.091-.73-.258-1.166c-.041-.157-.132-.304-.213-.484zm11.455.246c-.096.203-.203.384-.266.577-.168.516-.306 1.04-.343 1.581-.004.052-.019.072-.08.072l-.826-.007c-.032 0-.064-.005-.114-.009.32-.884.881-1.598 1.629-2.213v-.001zm-6.497.184c.667.553 1.124 1.218 1.342 2.032l-.141.007c-.256 0-.513-.004-.769.003-.097.003-.12-.028-.122-.109l-.04-.912c-.016-.273-.044-.545-.157-.803-.033-.074-.075-.145-.113-.218z" }),
				/* @__PURE__ */ _jsx("path", { d: "M56.612 106.147c-.005.019-.007.04-.018.056-.191.287-.281.611-.37.93-.226.8-.357 1.617-.468 2.437-.026.194.016.175-.213.178h-.181c-.765 0-1.532-.002-2.297.004-.099 0-.138-.018-.159-.11l-.468-2.163c-.126-.444-.257-.887-.454-1.31-.035-.074-.084-.142-.126-.213l.023-.015a7.42 7.42 0 0 1 1.008 1.143c.29.412.542.843.745 1.3.023-.718-.062-1.424-.148-2.129a8.73 8.73 0 0 0-.512-2.064c1.182 1.303 1.784 2.813 1.917 4.502.349-.979.951-1.808 1.721-2.546zm-9.041-.214c.805.674 1.39 1.491 1.807 2.418.284-1.262.918-2.344 1.873-3.273 0 .032-.014.058-.026.084-.054.122-.128.239-.157.365l-.256 1.242-.189 2.846v.108c-.03.007-.045.014-.059.014l-1.89.007c-.024 0-.064-.042-.068-.068l-.366-1.823c-.161-.655-.318-1.315-.667-1.92h-.002zm-1.202 1.344c.858.672 1.46 1.456 1.703 2.466-.371 0-.721.001-1.07-.004-.025 0-.066-.051-.071-.082l-.091-.73-.258-1.166c-.041-.157-.132-.304-.213-.484zm11.455.246c-.096.203-.203.384-.266.577-.168.516-.306 1.04-.343 1.581-.004.052-.019.072-.08.072l-.827-.007c-.032 0-.064-.005-.114-.009.32-.884.881-1.598 1.629-2.213v-.001zm-6.497.184c.667.553 1.124 1.218 1.342 2.032l-.141.007c-.256 0-.513-.004-.769.003-.097.003-.12-.028-.122-.109l-.04-.912c-.015-.273-.044-.545-.157-.803-.033-.074-.075-.145-.113-.218z" }),
				/* @__PURE__ */ _jsx("path", { d: "M52.793 106.147c-.005.019-.007.04-.018.056-.191.287-.281.611-.37.93-.226.8-.357 1.617-.467 2.437-.026.194.015.175-.213.178h-.181c-.766 0-1.532-.002-2.297.004-.098 0-.138-.018-.159-.11l-.468-2.163c-.126-.444-.257-.887-.454-1.31-.035-.074-.084-.142-.126-.213l.023-.015c.374.352.717.728 1.008 1.143s.542.843.745 1.3c.023-.718-.062-1.424-.148-2.129s-.256-1.393-.512-2.064c1.182 1.303 1.784 2.813 1.917 4.502.349-.979.95-1.808 1.72-2.546zm-9.041-.214c.805.674 1.39 1.491 1.807 2.418.284-1.262.919-2.344 1.873-3.273 0 .032-.014.058-.026.084-.054.122-.128.239-.157.365l-.256 1.242-.189 2.846v.108c-.03.007-.045.014-.059.014l-1.89.007c-.024 0-.064-.042-.068-.068l-.366-1.823c-.161-.655-.318-1.315-.667-1.92h-.002zm-1.202 1.344c.858.672 1.46 1.456 1.703 2.466-.371 0-.721.001-1.07-.004-.025 0-.066-.051-.071-.082l-.091-.73-.258-1.166c-.041-.157-.132-.304-.213-.484zm11.455.246c-.096.203-.203.384-.266.577-.168.516-.306 1.04-.343 1.581-.004.052-.019.072-.08.072l-.827-.007c-.032 0-.064-.005-.114-.009.32-.884.881-1.598 1.629-2.213v-.001zm-6.497.184c.667.553 1.124 1.218 1.342 2.032l-.141.007c-.256 0-.513-.004-.769.003-.097.003-.12-.028-.122-.109l-.04-.912c-.016-.273-.044-.545-.157-.803-.033-.074-.075-.145-.113-.218z" }),
				/* @__PURE__ */ _jsx("use", {
					href: "#J",
					x: -33
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.035 100.259H19.35v8.051h3.685z",
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 30.4048 89.5241)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 23.0352 87.735)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 25.7983 93.997)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 16.5864 93.1024)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 22.1138 80.5783)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 16.5864 85.9458)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M31.248 106.147c-.005.019-.007.04-.018.056-.191.287-.281.611-.37.93-.226.8-.357 1.617-.468 2.437-.026.194.015.175-.213.178h-.181c-.765 0-1.532-.002-2.297.004-.098 0-.138-.018-.159-.11l-.468-2.163c-.126-.444-.257-.887-.454-1.31-.035-.074-.084-.142-.126-.213l.023-.015c.375.352.717.728 1.008 1.143s.542.843.745 1.3c.023-.718-.062-1.424-.148-2.129s-.256-1.393-.512-2.064c1.182 1.303 1.784 2.813 1.917 4.502.349-.979.95-1.808 1.72-2.546zm-9.042-.214c.805.674 1.39 1.491 1.807 2.418.284-1.262.919-2.344 1.873-3.273 0 .032-.014.058-.026.084-.054.122-.127.239-.157.365l-.256 1.242-.189 2.846v.108c-.03.007-.045.014-.059.014l-1.89.007c-.024 0-.064-.042-.068-.068l-.366-1.823c-.161-.655-.318-1.315-.667-1.92h-.002zm-1.202 1.344c.858.672 1.46 1.456 1.703 2.466-.371 0-.721.001-1.07-.004-.025 0-.067-.051-.071-.082l-.091-.73-.258-1.166c-.041-.157-.132-.304-.213-.484zm11.455.246c-.096.203-.203.384-.266.577-.168.516-.306 1.04-.343 1.581-.004.052-.019.072-.08.072l-.826-.007c-.032 0-.064-.005-.114-.009.32-.884.881-1.598 1.629-2.213v-.001zm-6.497.184c.667.553 1.124 1.218 1.342 2.032l-.141.007c-.256 0-.513-.004-.769.003-.098.003-.12-.028-.122-.109l-.04-.912c-.015-.273-.044-.545-.157-.803-.033-.074-.075-.145-.113-.218z" }),
				/* @__PURE__ */ _jsx("path", { d: "M23.612 106.147c-.005.019-.007.04-.018.056-.191.287-.281.611-.37.93-.226.8-.357 1.617-.468 2.437-.026.194.015.175-.213.178h-.181c-.765 0-1.532-.002-2.297.004-.099 0-.138-.018-.159-.11l-.468-2.163c-.126-.444-.257-.887-.454-1.31-.035-.074-.084-.142-.126-.213l.023-.015a7.42 7.42 0 0 1 1.008 1.143c.29.412.542.843.745 1.3.023-.718-.062-1.424-.148-2.129a8.73 8.73 0 0 0-.512-2.064c1.182 1.303 1.784 2.813 1.917 4.502.349-.979.95-1.808 1.72-2.546zm-9.041-.214c.805.674 1.39 1.491 1.807 2.418.284-1.262.919-2.344 1.873-3.273 0 .032-.014.058-.026.084-.054.122-.128.239-.157.365l-.256 1.242-.189 2.846v.108c-.03.007-.045.014-.059.014l-1.89.007c-.024 0-.064-.042-.068-.068l-.366-1.823c-.161-.655-.318-1.315-.667-1.92h-.002zm-1.202 1.344c.858.672 1.46 1.456 1.703 2.466-.371 0-.721.001-1.07-.004-.025 0-.066-.051-.071-.082l-.091-.73-.258-1.166c-.041-.157-.132-.304-.213-.484zm11.455.246c-.096.203-.203.384-.266.577-.168.516-.306 1.04-.343 1.581-.004.052-.019.072-.08.072l-.826-.007c-.032 0-.064-.005-.114-.009.32-.884.881-1.598 1.629-2.213v-.001zm-6.497.184c.667.553 1.124 1.218 1.342 2.032l-.141.007c-.256 0-.513-.004-.769.003-.098.003-.12-.028-.122-.109l-.04-.912c-.015-.273-.044-.545-.157-.803-.033-.074-.075-.145-.113-.218z" }),
				/* @__PURE__ */ _jsx("path", { d: "M19.793 106.147c-.005.019-.007.04-.018.056-.191.287-.281.611-.37.93-.226.8-.357 1.617-.467 2.437-.026.194.015.175-.213.178h-.181c-.765 0-1.532-.002-2.297.004-.098 0-.138-.018-.159-.11l-.468-2.163c-.126-.444-.257-.887-.454-1.31-.035-.074-.084-.142-.126-.213l.023-.015c.375.352.717.728 1.008 1.143s.542.843.745 1.3c.023-.718-.062-1.424-.148-2.129s-.256-1.393-.512-2.064c1.182 1.303 1.784 2.813 1.917 4.502.349-.979.95-1.808 1.72-2.546zm-9.041-.214c.805.674 1.39 1.491 1.807 2.418.284-1.262.919-2.344 1.873-3.273 0 .032-.014.058-.025.084-.054.122-.128.239-.157.365l-.256 1.242-.189 2.846v.108c-.03.007-.045.014-.059.014l-1.89.007c-.024 0-.064-.042-.068-.068l-.366-1.823c-.161-.655-.318-1.315-.667-1.92h-.002zm-1.202 1.344c.858.672 1.46 1.456 1.703 2.466-.371 0-.721.001-1.07-.004-.025 0-.066-.051-.071-.082l-.091-.73-.258-1.166c-.041-.157-.132-.304-.213-.484zm11.455.246c-.096.203-.203.384-.266.577-.168.516-.306 1.04-.343 1.581-.004.052-.019.072-.08.072l-.826-.007c-.032 0-.064-.005-.114-.009.32-.884.881-1.598 1.629-2.213v-.001zm-6.497.184c.667.553 1.124 1.218 1.342 2.032l-.141.007c-.256 0-.513-.004-.769.003-.098.003-.12-.028-.122-.109l-.04-.912c-.015-.273-.044-.545-.157-.803-.033-.074-.075-.145-.113-.218z" })
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#2c3f81",
			strokeWidth: 3,
			children: [
				/* @__PURE__ */ _jsxs("g", {
					className: "E",
					children: [/* @__PURE__ */ _jsx("path", { d: "M95.994 3L78.983 31" }), /* @__PURE__ */ _jsx("path", { d: "M34.994 18h107" })]
				}),
				/* @__PURE__ */ _jsx("path", { d: "M144.756 1.5c3.478 0 5.641 3.777 3.881 6.777l-13.491 23a4.5 4.5 0 0 1-3.882 2.223H33.221c-3.478 0-5.641-3.777-3.882-6.777l13.491-23A4.5 4.5 0 0 1 46.712 1.5h98.044z" }),
				/* @__PURE__ */ _jsxs("g", {
					className: "E",
					children: [/* @__PURE__ */ _jsx("path", { d: "M216.994 3L199.983 31" }), /* @__PURE__ */ _jsx("path", { d: "M155.994 18h107" })]
				}),
				/* @__PURE__ */ _jsx("path", { d: "M265.756 1.5c3.478 0 5.641 3.777 3.881 6.777l-13.491 23a4.5 4.5 0 0 1-3.882 2.223H154.22c-3.477 0-5.641-3.777-3.881-6.777l13.491-23a4.5 4.5 0 0 1 3.882-2.223h98.044z" }),
				/* @__PURE__ */ _jsxs("g", {
					className: "E",
					children: [/* @__PURE__ */ _jsx("path", { d: "M335.994 3L318.983 31" }), /* @__PURE__ */ _jsx("path", { d: "M274.994 18h107" })]
				}),
				/* @__PURE__ */ _jsx("path", { d: "M384.756 1.5c3.478 0 5.641 3.777 3.881 6.777l-13.491 23a4.5 4.5 0 0 1-3.882 2.223H273.22c-3.477 0-5.641-3.777-3.881-6.777l13.491-23a4.5 4.5 0 0 1 3.882-2.223h98.044z" })
			]
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#E",
			x: 132,
			className: "B"
		}),
		/* @__PURE__ */ _jsx("use", {
			href: "#F",
			x: 132,
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "D",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 393.405 89.5241)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 386.035 87.735)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 388.798 93.997)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 379.586 93.1024)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 385.114 80.5783)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 1.382,
					cy: 1.342,
					rx: 1.382,
					ry: 1.342,
					transform: "matrix(-1 0 0 1 379.586 85.9458)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "B",
			children: [
				/* @__PURE__ */ _jsx("use", {
					href: "#G",
					x: 132
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#H",
					x: 132
				}),
				/* @__PURE__ */ _jsx("use", {
					href: "#I",
					x: 132
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403.994 111.04a2.41 2.41 0 0 0-2.419-2.396L2.403 109.697c-1.325.003-2.396 1.083-2.387 2.409l403.978-1.066z",
			className: "C"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("path", {
				id: "E",
				d: "M262.973 109.839l-9.617-.395v-8.762l3.906-.026c2.401-.015 4.442-.85 6.123-2.505a8 8 0 0 0 2.498-5.98c-.012-1.686-.5-3.235-1.464-4.647s-2.259-2.437-3.884-3.072c-.275-2.105-1.235-3.862-2.879-5.27s-3.566-2.105-5.765-2.091a8.49 8.49 0 0 0-5.735 2.166c-1.625 1.429-2.56 3.199-2.806 5.307-1.616.657-2.896 1.698-3.841 3.123s-1.412 2.98-1.4 4.666c.016 2.332.876 4.314 2.58 5.947s3.756 2.441 6.157 2.425l3.906-.025v8.788l-10.063-.043.152.539 22.132-.144z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "F",
				d: "M254.035 100.259h-3.685v8.051h3.685z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "G",
				d: "M262.248 106.147c-.006.019-.007.04-.018.056-.192.287-.281.611-.37.93-.226.8-.357 1.617-.468 2.437-.026.194.016.175-.213.178h-.181c-.766 0-1.532-.002-2.298.004-.098 0-.137-.018-.158-.11l-.469-2.163c-.125-.444-.257-.887-.453-1.31-.035-.074-.084-.142-.126-.213l.023-.015a7.47 7.47 0 0 1 1.008 1.143c.289.412.542.843.745 1.3.023-.718-.062-1.424-.148-2.129a8.7 8.7 0 0 0-.512-2.064c1.182 1.303 1.784 2.813 1.917 4.502.349-.979.951-1.808 1.721-2.546zm-9.042-.214c.805.674 1.39 1.491 1.807 2.418.285-1.262.919-2.344 1.873-3.273 0 .032-.014.058-.025.084-.054.122-.128.239-.157.365l-.256 1.242c-.11.945-.205 1.893-.189 2.846v.108c-.03.007-.045.014-.059.014l-1.89.007c-.024 0-.064-.042-.068-.068l-.367-1.823c-.161-.655-.318-1.315-.667-1.92h-.002zm-1.202 1.344c.859.672 1.46 1.456 1.704 2.466-.371 0-.721.001-1.07-.004-.025 0-.067-.051-.071-.082l-.091-.73-.258-1.166c-.041-.157-.132-.304-.214-.484zm11.455.246c-.096.203-.203.384-.266.577-.168.516-.306 1.04-.343 1.581-.003.052-.019.072-.08.072l-.826-.007c-.032 0-.064-.005-.114-.009.32-.884.881-1.598 1.629-2.213v-.001zm-6.497.184c.667.553 1.123 1.218 1.342 2.032l-.141.007c-.256 0-.513-.004-.769.003-.098.003-.121-.028-.122-.109l-.041-.912c-.015-.273-.043-.545-.156-.803-.033-.074-.075-.145-.113-.218z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "H",
				d: "M254.612 106.147c-.006.019-.008.04-.019.056-.191.287-.28.611-.37.93-.226.8-.357 1.617-.467 2.437-.026.194.016.175-.213.178h-.182c-.765 0-1.531-.002-2.297.004-.098 0-.137-.018-.158-.11l-.469-2.163c-.126-.444-.257-.887-.454-1.31-.034-.074-.083-.142-.125-.213l.022-.015c.375.352.718.728 1.008 1.143a7.74 7.74 0 0 1 .746 1.3c.022-.718-.062-1.424-.148-2.129a8.75 8.75 0 0 0-.512-2.064c1.182 1.303 1.784 2.813 1.917 4.502.349-.979.951-1.808 1.721-2.546zm-9.042-.214c.805.674 1.39 1.491 1.807 2.418.285-1.262.919-2.344 1.873-3.273 0 .032-.014.058-.026.084-.053.122-.127.239-.156.365l-.256 1.242c-.11.945-.206 1.893-.189 2.846v.108c-.03.007-.045.014-.059.014l-1.89.007c-.024 0-.064-.042-.069-.068l-.366-1.823c-.161-.655-.318-1.315-.667-1.92h-.002zm-1.202 1.344c.859.672 1.46 1.456 1.703 2.466-.371 0-.72.001-1.069-.004-.025 0-.067-.051-.072-.082l-.091-.73-.258-1.166c-.041-.157-.132-.304-.213-.484zm11.455.246c-.096.203-.203.384-.266.577-.168.516-.307 1.04-.343 1.581-.004.052-.019.072-.08.072l-.827-.007c-.032 0-.063-.005-.114-.009.32-.884.882-1.598 1.63-2.213v-.001zm-6.498.184c.668.553 1.124 1.218 1.343 2.032l-.141.007c-.257 0-.514-.004-.77.003-.097.003-.12-.028-.122-.109l-.04-.912c-.015-.273-.044-.545-.157-.803-.032-.074-.074-.145-.113-.218z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "I",
				d: "M250.793 106.147c-.005.019-.007.04-.018.056-.191.287-.281.611-.37.93-.226.8-.357 1.617-.467 2.437-.027.194.015.175-.214.178h-.181c-.765 0-1.532-.002-2.297.004-.099 0-.138-.018-.159-.11l-.468-2.163c-.126-.444-.257-.887-.454-1.31-.035-.074-.084-.142-.126-.213l.023-.015c.375.352.717.728 1.008 1.143s.542.843.745 1.3c.023-.718-.062-1.424-.147-2.129a8.75 8.75 0 0 0-.512-2.064c1.181 1.303 1.784 2.813 1.917 4.502.349-.979.95-1.808 1.72-2.546zm-9.041-.214c.804.674 1.389 1.491 1.807 2.418.284-1.262.918-2.344 1.872-3.273 0 .032-.013.058-.025.084-.054.122-.128.239-.157.365l-.256 1.242-.188 2.846v.108c-.031.007-.045.014-.06.014l-1.89.007c-.023 0-.063-.042-.068-.068l-.366-1.823c-.162-.655-.318-1.315-.667-1.92h-.002zm-1.202 1.344c.858.672 1.46 1.456 1.703 2.466-.371 0-.721.001-1.07-.004-.024 0-.066-.051-.071-.082l-.091-.73-.258-1.166c-.041-.157-.132-.304-.213-.484zm11.454.246c-.095.203-.203.384-.266.577-.167.516-.306 1.04-.342 1.581-.004.052-.019.072-.081.072l-.826-.007c-.032 0-.064-.005-.114-.009.32-.884.881-1.598 1.629-2.213v-.001zm-6.497.184c.667.553 1.124 1.218 1.342 2.032l-.141.007c-.256 0-.513-.004-.769.003-.097.003-.12-.028-.122-.109l-.04-.912c-.016-.273-.044-.545-.157-.803-.033-.074-.075-.145-.113-.218z"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "J",
				d: "M64.973 109.839l-9.617-.395v-8.762l3.906-.026c2.401-.015 4.442-.85 6.124-2.505s2.514-3.648 2.498-5.98a8.17 8.17 0 0 0-1.464-4.647c-.965-1.413-2.259-2.437-3.884-3.072a8.11 8.11 0 0 0-2.879-5.27c-1.644-1.408-3.566-2.105-5.765-2.091s-4.111.736-5.735 2.166-2.56 3.199-2.806 5.307c-1.616.657-2.896 1.698-3.841 3.123s-1.412 2.98-1.4 4.666c.016 2.332.876 4.314 2.58 5.947s3.756 2.441 6.158 2.425l3.906-.025v8.788l-10.063-.043.152.539 22.132-.144z"
			})
		] })
	]
});
export default SvgShading5075;
